import React, { useEffect } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { getConfig } from '../../config/getConfig';

const OidcLogout = () => {
  useEffect(() => {
    const handleLogout = () => {
      console.log('🚪 OIDC 로그아웃 시작...');

      // 0) id_token 확보 (Keycloak SSO 세션 종료를 위한 id_token_hint)
      const idToken = localStorage.getItem('oidc_id_token') || localStorage.getItem('id_token');

      // 1) localStorage에서 모든 토큰 제거 (OIDC + 기타)
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('oidc_access_token');
      localStorage.removeItem('oidc_refresh_token');
      localStorage.removeItem('oidc_id_token');

      // 2) sessionStorage에서 모든 SafeDB 토큰 제거
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('refreshToken');
      sessionStorage.removeItem('siteToken');
      sessionStorage.removeItem('user');

      // 3) 전체 스토리지 클리어 (확실한 제거)
      try {
        localStorage.clear();
        sessionStorage.clear();
      } catch (e) {
        console.warn('Storage clear error:', e);
      }

      console.log('✅ 로컬 토큰 제거 완료');

      // 4) Keycloak 완전 로그아웃 URL 생성 (id_token_hint 포함)
      const { SSO_KEYCLOAK_URL, SSO_REALM, SSO_CLIENT_ID } = getConfig();
      const keycloakUrl = SSO_KEYCLOAK_URL || process.env.REACT_APP_SSO_KEYCLOAK_URL || 'http://localhost:8080';
      const realm = SSO_REALM || process.env.REACT_APP_SSO_REALM || 'safedb';
      const clientId = SSO_CLIENT_ID || process.env.REACT_APP_SSO_CLIENT_ID || 'safedb-frontend';
      const redirectUri = `${window.location.origin}/login`;

      const params = new URLSearchParams({
        post_logout_redirect_uri: redirectUri,
        client_id: clientId
      });
      if (idToken) {
        params.set('id_token_hint', idToken);
      }
      const logoutUrl = `${keycloakUrl}/realms/${realm}/protocol/openid-connect/logout?${params.toString()}`;

      console.log('🔗 Keycloak 로그아웃 URL:', logoutUrl);

      // 5) Keycloak 로그아웃 페이지로 즉시 리다이렉트 (세션 완전 종료)
      window.location.assign(logoutUrl);
    };

    handleLogout();
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <Card style={{ maxWidth: '400px', width: '100%' }}>
        <Card.Body className="text-center p-5">
          <div className="mb-4">
            <FontAwesomeIcon icon={faSignOutAlt} size="3x" className="text-primary" />
          </div>

          <h4 className="mb-3">로그아웃 중...</h4>

          <div className="mb-4">
            <Spinner animation="border" variant="primary" />
          </div>

          <p className="text-muted mb-0">
            안전하게 로그아웃하고 있습니다.<br />
            잠시만 기다려주세요...
          </p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default OidcLogout;
